import * as requestFromServer from "./Crud";
import {Slice, callTypes} from "./Slice";
import { NotificationManager } from "react-notifications";

const {actions} = Slice;

export const uploadImage = (queryParams) => dispatch => {
    return requestFromServer
    .uploadImage(queryParams.img)
    .then(response => {
      console.log("response",response)
      const entities = response.data;      
      const imageField = queryParams.name;      
      dispatch(actions.imageUploaded({ entities, imageField }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
